export default __webpack_public_path__ + "static/2-a28849194a70e5a99b28c11ef832503a.jpeg";